import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card } from 'antd';
import { makeStyles } from '@material-ui/styles';
import { capitalize } from 'lodash';

import { dayFormatType, moment } from '~helpers/day';
import { ArrowRightCMS } from 'common/components/svgs';

import useCommonStyle from '../../style';

const formatStatusStr = str =>
  str
    ?.split('_')
    ?.map(item => capitalize(item))
    ?.join(' ');

const useStyles = makeStyles(theme => ({
  noBorder: {
    borderBottom: 'none',
    '& .ant-card-head-title': {
      marginBottom: 12,
      fontWeight: 600,
    },
  },
  statusLog: {
    paddingBottom: 24,
    borderBottom: `1px solid rgba(0,0,0,0.09)`,

    '&:first-child': {
      paddingTop: 0,
    },

    '&:last-child': {
      paddingBottom: 0,
      borderBottom: 'none',
    },
  },
  statusLogNote: {
    ...theme.typography.body2,
    color: theme.colors.bodyColor,
    marginBottom: 12,
  },
  statusLogTag: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
    marginTop: 12,

    '& .status-tag': {
      padding: '1px 10px',
      borderRadius: '12px',
      ...theme.typography.body2,
      color: 'rgba(0, 0, 0, 0.85)',
      backgroundColor: theme.colors.gray3,
      display: 'flex',
      alignItems: 'center',
    },

    '& .status-tag-pending::before': {
      content: '""',
      display: 'inline-block',
      height: 6,
      width: 6,
      borderRadius: 3,
      marginRight: 8,
      backgroundColor: theme.colors.orange6,
    },
    '& .status-tag-verified::before': {
      content: '""',
      display: 'inline-block',
      height: 6,
      width: 6,
      borderRadius: 3,
      marginRight: 8,
      backgroundColor: theme.colors.green6,
    },
    '& .status-tag-rejected::before': {
      content: '""',
      display: 'inline-block',
      height: 6,
      width: 6,
      borderRadius: 3,
      marginRight: 8,
      backgroundColor: theme.colors.red11,
    },
    '& .status-tag-lost::before': {
      content: '""',
      display: 'inline-block',
      height: 6,
      width: 6,
      borderRadius: 3,
      marginRight: 8,
      backgroundColor: theme.colors.gray8,
    },
    '& .status-tag-unpublished::before': {
      content: '""',
      display: 'inline-block',
      height: 6,
      width: 6,
      borderRadius: 3,
      marginRight: 8,
      backgroundColor: theme.colors.gray7,
    },
    '& .status-tag-onboarding::before': {
      content: '""',
      display: 'inline-block',
      height: 6,
      width: 6,
      borderRadius: 3,
      marginRight: 8,
      backgroundColor: theme.colors.blue6,
    },
    '& .status-tag-in_consultation::before': {
      content: '""',
      display: 'inline-block',
      height: 6,
      width: 6,
      borderRadius: 3,
      marginRight: 8,
      backgroundColor: '#40A9FF',
    },
  },
  statusLogArrow: {
    margin: '0 8px',
  },
  statusLogUpdated: {
    ...theme.typography.body4,
    color: theme.colors.disableColor,
  },
}));

const LandlordStatus = ({ landlordStatusLog }) => {
  const { t } = useTranslation();
  const commonClasses = useCommonStyle();
  const classes = useStyles();

  return (
    <Row>
      <Col span={24}>
        <Card
          title={t('cms.landlord.verification.landlord_status')}
          className={[commonClasses.cardWrapper, classes.noBorder]}
          bordered={false}
        >
          <For of={landlordStatusLog} each="log">
            <div className={classes.statusLog}>
              <If condition={log.notes}>
                <div className={classes.statusLogNote}>{log.notes}</div>
              </If>
              <div className={classes.statusLogTag}>
                <span className={`status-tag status-tag-${log.oldStatus.toLowerCase()}`}>
                  {formatStatusStr(log.oldStatus)}
                </span>
                <ArrowRightCMS className={classes.statusLogArrow} />
                <span className={`status-tag status-tag-${log.newStatus.toLowerCase()}`}>
                  {formatStatusStr(log.newStatus)}
                </span>
              </div>
              <div className={classes.statusLogUpdated}>
                {t('cms.landlord.landlord_status.updated.text', {
                  updateBy: log.updateBy,
                  updatedAt: moment(log.updatedAt).format(dayFormatType.UKFORMAT),
                })}
              </div>
            </div>
          </For>
        </Card>
      </Col>
    </Row>
  );
};

export default LandlordStatus;
